import React from 'react';
import MuiAutocomplete from '@mui/material/Autocomplete';
import * as icons from '../../utils/icons';
import {Colors} from '../../utils/style/colors';
import {Flex} from '../Container/Flex';
import {Comment, Text} from '../../utils/style/texts';
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

const iconList = Object.keys(icons).map(i => i.replace(/Icon$/, ''));

const IconPicker = (({style, label, onChange, value, ...other}) => {
    const IconValue = icons[value];
    return (
        <label style={{display: 'flex', alignItems: 'center'}}>
            {label && (
                <Text style={{
                    marginRight: 10,
                    marginTop: 10,
                    marginBottom: 5,
                    opacity: other.disabled ? .5 : 1
                }}>{label}</Text>
            )}
            <MuiAutocomplete
                style={{
                    ...style,
                    opacity: other.disabled ? .5 : 1,
                }}
                disableClearable
                renderOption={(props, {value}) => {
                    const Icon = icons[`${value}Icon`];
                    if (!Icon) return null;
                    return (
                        <Flex row {...props}>
                            <Icon color={Colors.gray60} size={1}/>
                            <Comment>&nbsp;&nbsp;{value}</Comment>
                        </Flex>
                    )
                }}
                {...other}
                onInputChange={(e, value) => onChange(`${value}Icon`)}
                sx={{width: 200}}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        InputProps={{
                            ...params.InputProps,
                            startAdornment: IconValue ? (
                                <InputAdornment position="start">
                                    <IconValue size={1} color={Colors.gray60} />
                                </InputAdornment>
                            ) : null,
                        }}
                    />
                )}
                value={value.replace(/Icon$/, '')}
                options={iconList.map(i => ({
                    label: i,
                    value: i
                }))}
            />
        </label>
    );

});

export default IconPicker;